import React from 'react';
import { GetPaginatedAutomationRunsQuery } from 'shared/types/graphql';
import AutomationRun from 'pages/Conversations/components/ChannelMessage/MessageBubble/Attachments/AutomationRun';
import { HStack, useDisclosure } from '@televet/kibble-ui/build/chakra';
import { Modal, ModalBody, ModalCloseButton } from '@televet/kibble-ui/build/components/Modal';
import { Card, Heading, Icon } from '@televet/kibble-ui';

interface AutomationCardBodyProps {
  automationRunData: NonNullable<GetPaginatedAutomationRunsQuery['automationRuns']>[0];
}

const AutomationCardBody = ({ automationRunData }: AutomationCardBodyProps): JSX.Element => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Card className="Board__Card-AutomationDetails" bg="transparent" isInteractive onClick={onOpen} my={2}>
        <HStack justify="space-between">
          <Heading size="sm">{automationRunData.originAutomation.name}</Heading>
          <Icon name="externalLink" size="sm" />
        </HStack>
      </Card>
      <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
        <ModalCloseButton />
        <ModalBody>
          <AutomationRun
            automationRunId={automationRunData?.id}
            hideBorder
            hideCollapse
            isLastEligibleMessage={true}
            setCurrentInvoiceId={(): void => {
              // This is a required prop on the AutomationRun component
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default AutomationCardBody;
